import {BaseModel} from "../../_base/crud";

export class AttachmentsModel  extends BaseModel{
    id:number;
    link:string;
}
